import { render, staticRenderFns } from "./go.vue?vue&type=template&id=5d48cf0e&"
import script from "./go.vue?vue&type=script&lang=js&"
export * from "./go.vue?vue&type=script&lang=js&"
import style0 from "./go.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports